import { postUrl } from '../fetch';

import { IGetLoginViaCode } from './loginViaCodeTypes';

export async function loginViaCode(
    code: string | undefined
): Promise<IGetLoginViaCode | undefined> {
    const url = `/api/urlShortener/login`;

    const header = code
        ? {
              Authorization: `Bearer ${code}`,
          }
        : {};
    const response = await postUrl<IGetLoginViaCode>(
        url,
        {},
        { headers: header }
    );

    if (response) {
        return response;
    } else {
        console.error('Error logging in via code:', response);
        return undefined;
    }
}
